// Cart bar: size selection + direct add to cart (multi-variant products)
document.addEventListener('DOMContentLoaded', function () {
  const cartBar = document.getElementById('cart-bar');
  if (!cartBar) return;

  const addButton = cartBar.querySelector('[data-cart-bar-multi-add]');
  if (!addButton) return;

  const form = addButton.closest('form');
  if (!form) return;

  const variantJsonEl = form.querySelector('[data-cart-bar-variant-json]');
  const variantIdInput = form.querySelector('[data-cart-bar-variant-id]');
  const optionInputs = form.querySelectorAll('[data-cart-bar-option-input]');

  // No size/option selector rendered (e.g. product only varies by color) —
  // just wire up the click, the preselected variant id is already correct.
  if (!variantJsonEl || !variantIdInput || !optionInputs.length) {
    addButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (addButton.disabled) return;

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          bubbles: true,
          detail: { button: addButton },
        })
      );
    });
    return;
  }

  const variantData = JSON.parse(variantJsonEl.textContent);

  function updateVariant() {
    const selected = [];

    optionInputs.forEach(function (input) {
      const position = parseInt(input.getAttribute('data-option-position'), 10);
      selected[position - 1] = input.value;
    });

    const match = variantData.find(function (variant) {
      const options = [variant.option1, variant.option2, variant.option3];
      return selected.every(function (value, index) {
        return !value || value === options[index];
      });
    });

    if (!match) return;

    variantIdInput.value = match.id;
    addButton.disabled = !match.available;
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', updateVariant);
  });

  addButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (addButton.disabled) return;

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: { button: addButton },
      })
    );
  });
});
